/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withDefault } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

// required attributes
const CreditorInstitutionR = t.interface({
  business_name: t.string,

  creditor_institution_code: t.string,

  enabled: withDefault(t.boolean, true)
});

// optional attributes
const CreditorInstitutionO = t.partial({
  description: t.string
});

export const CreditorInstitution = t.intersection(
  [CreditorInstitutionR, CreditorInstitutionO],
  "CreditorInstitution"
);

export type CreditorInstitution = t.TypeOf<typeof CreditorInstitution>;
